const HEARTBEAT_TIMEOUT_MS = 90_000;

type AgentStatusSnapshot = {
  statusName: string;
  softphoneConnected: boolean | null;
  lastHeartbeat: string;
};

export function isSoftphoneConnected(status: AgentStatusSnapshot | null | undefined, now: number) {
  if (!status) return false;
  if (typeof status.softphoneConnected === 'boolean') return status.softphoneConnected;

  return status.statusName !== 'offline' && new Date(status.lastHeartbeat).getTime() >= now - HEARTBEAT_TIMEOUT_MS;
}

export const AGENT_EVENT_LABELS: Record<string, string> = {
  login: 'Logged in',
  logout: 'Logged out',
  status_change: 'Status changed',
  call_offered: 'Call offered',
  call_answered: 'Call answered',
  call_completed: 'Call completed',
  call_missed: 'Call missed',
  transfer_initiated: 'Transfer initiated',
  transfer_completed: 'Transfer completed',
  wrap_up_start: 'Wrap-up started',
  wrap_up_end: 'Wrap-up ended',
  forced_status_change: 'Status forced',
  queue_joined: 'Joined queue',
  queue_left: 'Left queue',
};

export const DIALPAD_KEYS = ['1', '2', '3', '4', '5', '6', '7', '8', '9', '*', '0', '#'];
